import {getTimestampNow} from "../../../util/Util";
import {
    deleteAutoRetrieverDeviceDetails,
    fetchAutoRetrieverDeviceDetails,
    fetchPickStationResources,
    setAutoRetrieverDeviceDetails, startMockTestForAutoRetriever,
    updateAutoRetrieverDeviceDetails, updateAutoRetrieverDeviceMac,
    updateAutoRetrieverMonitoringDetails, updatePickStationConfig
} from "../network/AutoRetrieverDeviceNetworkAPI";

export const AutoRetrieverDeviceOverviewReducer = (state, action) => {
    switch(action.type) {
        case "LOAD_VIEW":
            fetchAutoRetrieverDeviceDetails(action.data.dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_DEVICE_DATA":
            setAutoRetrieverDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAutoRetrieverDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_MAC":
            updateAutoRetrieverDeviceMac(action.data.dispatcher, action.data.stateValues, action.data.mac,
                action.data.showCustomAlert)
            return state
        case "UPDATE_MONITORING_DATA":
            updateAutoRetrieverMonitoringDetails(action.data.dispatcher, action.data.stateValues,
                action.data.mac)
            return state
        case "DELETE_DEVICE_DATA":
            deleteAutoRetrieverDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "START_MOCK_TEST":
            startMockTestForAutoRetriever(action.data.dispatcher, action.data.mac, action.data.showCustomAlert)
            return {...state, loadingOverview: true}
        case "LOAD_PICK_STATION_RESOURCES":
            fetchPickStationResources(action.data.dispatcher)
            return {...state, loadingPickStationResources: true}
        case "RECEIVE_PICK_STATION_RESOURCES":
            return {...state, pickStationResources: action.data, loadingPickStationResources: false}
        case "SAVE_PICK_STATION_CONFIG":
            updatePickStationConfig(action.data.dispatcher, action.data.mac,
                action.data.config, action.data.showCustomAlert)
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoretriever/reducer/AutoRetrieverDeviceOverviewReducer.js